import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { functionalOptionCode } from 'reducers/functionalOptionCodeMappings/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  functionalOptionCode,
});

export default compose(
  connect(mapStateToProps),
  flattenProp('functionalOptionCode'),
);
